import React from "react";
import { motion } from "framer-motion";
import { alpha } from "@mui/material/styles";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import {
  getStatusNumberBackgroundColor,
  getStatusNumberText,
} from "../../../../utils/orders";
import {
  getStatusIcon,
  getStatusNumberIcon,
} from "../../../../common/statusIcons";
import { ANIMATION_VARIANTS } from "../../../../types/order";

const OrderStatusBadge = ({
  statusNumber,
  status,
  hasExtraDelivery,
  theme,
  isMobile = false,
}) => {
  const backgroundColor = getStatusNumberBackgroundColor(statusNumber);
  const statusText = getStatusNumberText(statusNumber);
  const icon = statusNumber
    ? getStatusNumberIcon(statusNumber)
    : getStatusIcon(status);
  const shouldPulse = statusNumber === 0;
  const padding = isMobile ? 0.6 : 0.75;

  const statusBadgeVariants = {
    pulse: {
      scale: [1, 1.05, 1],
      transition: {
        repeat: Infinity,
        repeatType: "loop",
        duration: 2,
      },
    },
  };

  const boxShadow = hasExtraDelivery
    ? `0 0 0 2px ${alpha(
        theme.palette.background.paper,
        0.9
      )}, 0 4px 6px ${alpha(theme.palette.common.black, 0.2)}`
    : "none";

  return (
    <Box sx={{ position: "relative" }}>
      <Box
        component={motion.div}
        variants={statusBadgeVariants}
        animate={shouldPulse ? "pulse" : ""}
        sx={{
          position: "relative",
          zIndex: 2,
          boxShadow,
        }}
      >
        <Tooltip title={statusText}>
          <IconButton
            component={motion.button}
            variants={ANIMATION_VARIANTS.icon}
            whileHover="hover"
            whileTap="tap"
            sx={{
              p: padding,
              bgcolor: alpha(backgroundColor, 0.6),
              color: backgroundColor,
              "&:hover": {
                bgcolor: alpha(backgroundColor, 0.25),
              },
            }}
            aria-label={`Status: ${statusText}`}
          >
            {icon}
          </IconButton>
        </Tooltip>
      </Box>

      {hasExtraDelivery && (
        <Box
          sx={{
            position: "absolute",
            top: "60%",
            left: "75%",
            transform: "translate(-50%, -50%)",
            zIndex: 1,
          }}
        >
          <Tooltip title="Corrida Extra">
            <IconButton
              size="small"
              sx={{
                p: 0.5,
                bgcolor: alpha(theme.palette.warning.main, 0.15),
                color: theme.palette.warning.main,
                "&:hover": {
                  bgcolor: alpha(theme.palette.warning.main, 0.25),
                },
              }}
              aria-label="Corrida Extra"
            >
              {getStatusNumberIcon(5)}
            </IconButton>
          </Tooltip>
        </Box>
      )}
    </Box>
  );
};

export default React.memo(OrderStatusBadge);
